﻿import './credencial-usuario.css';

var centralApp = angular.module('app.components');

centralApp.component('credencialUsuario', {
    bindings: {
        credencial: '='
    },
    controller: credencialUsuarioCtrl,
    template: require('./credencial-usuario-template.html')
});

credencialUsuarioCtrl.$inject = ['$sessionStorage', 'Usuario', 'ConfigApp'];
function credencialUsuarioCtrl($sessionStorage, Usuario, ConfigApp) 
{
    var $ctrl = this;

    Usuario.credencial().then(function ( perfil ) {
        var credencial = perfil.data.credencial;

        credencial.foto = ConfigApp.LinkFoto( credencial.usuario )

        $ctrl.credencial = credencial;
    });

    $ctrl.$onInit = function(){
        $ctrl.credencial = $ctrl.credencial || {};
    }
}


//////////////////
// WEBPACK FOOTER
// ../Projecao.ContactCenter.WebApp.Compartilhado/components/credencial-usuario/index.js
// module id = 312
// module chunks = 1